module.exports = __webpack_public_path__ + "static/media/hyundai-phone.689b30aa.svg";